import React from 'react';
import { Heart, AlertCircle, Trophy, Star, Award } from 'lucide-react';

const Stats = ({ horseData, evaluationData }) => {
  const horsesWithEvaluations = horseData.filter(horse => 
    evaluationData.some(evaluation => evaluation.id === horse.id)
  );

  const validEvaluations = evaluationData.filter(evaluation => evaluation.totalScore !== null);
  
  const stats = {
    living: horseData.filter(h => h.status === 'Lifandi').length,
    dead: horseData.filter(h => h.status === 'Fallin').length,
    unknown: horseData.filter(h => h.status === 'Óþekkt').length,
    total: horseData.length,
    avgRating: Math.round(horseData.reduce((sum, h) => sum + h.rating, 0) / horseData.length),
    totalEvaluations: evaluationData.length,
    horsesWithEvaluations: horsesWithEvaluations.length,
    avgEvaluationScore: validEvaluations.length > 0 
      ? (validEvaluations.reduce((sum, evaluation) => sum + evaluation.totalScore, 0) / validEvaluations.length).toFixed(2)
      : 0
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Hestaheimur</h1>
          <p className="text-gray-600">Hross frá Hólabaki</p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-blue-600">{stats.total}</div>
          <div className="text-sm text-gray-500">hross skráð</div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
        <div className="bg-green-50 p-4 rounded-lg">
          <div className="flex items-center">
            <Heart className="w-5 h-5 text-green-500 mr-2" />
            <div>
              <div className="text-lg font-semibold text-green-700">{stats.living}</div>
              <div className="text-xs text-green-600">Lifandi</div>
            </div>
          </div>
        </div>
        
        <div className="bg-red-50 p-4 rounded-lg">
          <div className="flex items-center">
            <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
            <div>
              <div className="text-lg font-semibold text-red-700">{stats.dead}</div>
              <div className="text-xs text-red-600">Fallin</div>
            </div>
          </div>
        </div>
                
        <div className="bg-blue-50 p-4 rounded-lg">
          <div className="flex items-center">
            <Award className="w-5 h-5 text-blue-500 mr-2" />
            <div>
              <div className="text-lg font-semibold text-blue-700">{stats.avgRating}</div>
              <div className="text-xs text-blue-600">Meðal kynbótamat</div>
            </div>
          </div>
        </div>
        
        <div className="bg-purple-50 p-4 rounded-lg">
          <div className="flex items-center">
            <Trophy className="w-5 h-5 text-purple-500 mr-2" />
            <div>
              <div className="text-lg font-semibold text-purple-700">{stats.totalEvaluations}</div>
              <div className="text-xs text-purple-600">Dómar alls</div>
            </div>
          </div>
        </div>
        
        <div className="bg-indigo-50 p-4 rounded-lg">
          <div className="flex items-center">
            <Star className="w-5 h-5 text-indigo-500 mr-2" />
            <div>
              <div className="text-lg font-semibold text-indigo-700">{stats.horsesWithEvaluations}</div>
              <div className="text-xs text-indigo-600">Hross með dóma</div>
            </div>
          </div>
        </div>
        

      </div>
    </div>
  );
};

export default Stats;